import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

// import p1 from 'assests/Photos/SchoolProgram/2024/orientation/1.jpg';
// import p2 from 'assests/Photos/SchoolProgram/2024/orientation/2.jpg';
// import p3 from 'assests/Photos/SchoolProgram/2024/orientation/3.jpg';
// import p4 from 'assests/Photos/SchoolProgram/2024/orientation/4.jpg';
// import p5 from 'assests/Photos/SchoolProgram/2024/orientation/5.jpg';
// import p6 from 'assests/Photos/SchoolProgram/2024/orientation/6.jpg';


// import p5 from 'assests/Photos/SchoolProgram/2023/Valediction_ceremony/5.jpg';
// import p6 from 'assests/Photos/SchoolProgram/2023/RepublicDay/6.jpg';
// import p7 from 'assests/Photos/SchoolProgram/2023/RepublicDay/7.jpg';
// import p8 from 'assests/Photos/SchoolProgram/2023/RepublicDay/8.jpg';
// import p9 from 'assests/Photos/SchoolProgram/2023/RepublicDay/9.jpg';
// import p10 from 'assests/Photos/SchoolProgram/2023/RepublicDay/10.jpg';


import { Typography } from '@mui/material';
import Container from 'components/Container';
import Archive2022 from '../SchoolProgram2023/components/Archive2022';
import { Sidebar2026 } from '../SchoolProgram2023/components';

const Elevate2026 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });
    const [config, setConfig] = useState({ base_image_url_2026: '' });
    useEffect(() => {
      fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
        .then(response => response.json())
        .then(data => setConfig(data))
        .catch(error => console.error('Error fetching config:', error));
    }, []);
    
    const p1 = `${config.base_image_url_2026}/home/events-activities/school-programs/Elevate2026/1.webp`;
    const p2 = `${config.base_image_url_2026}/home/events-activities/school-programs/Elevate2026/2.webp`;
    const p3 = `${config.base_image_url_2026}/home/events-activities/school-programs/Elevate2026/3.webp`;
    const p4 = `${config.base_image_url_2026}/home/events-activities/school-programs/Elevate2026/4.webp`;
    const p5 = `${config.base_image_url_2026}/home/events-activities/school-programs/Elevate2026/5.webp`;
    const p6 = `${config.base_image_url_2026}/home/events-activities/school-programs/Elevate2026/6.webp`;
    const p7  = `${config.base_image_url_2026}/home/events-activities/school-programs/Elevate2026/7.webp`;
    const p8  = `${config.base_image_url_2026}/home/events-activities/school-programs/Elevate2026/8.webp`;
    const p9  = `${config.base_image_url_2026}/home/events-activities/school-programs/Elevate2026/9.webp`;
    const p10 = `${config.base_image_url_2026}/home/events-activities/school-programs/Elevate2026/10.webp`;
    const p11 = `${config.base_image_url_2026}/home/events-activities/school-programs/Elevate2026/11.webp`;
    const p12 = `${config.base_image_url_2026}/home/events-activities/school-programs/Elevate2026/12.webp`;
    const p13 = `${config.base_image_url_2026}/home/events-activities/school-programs/Elevate2026/13.webp`;
    const p14 = `${config.base_image_url_2026}/home/events-activities/school-programs/Elevate2026/14.webp`;
    const p15 = `${config.base_image_url_2026}/home/events-activities/school-programs/Elevate2026/15.webp`;
    const p16 = `${config.base_image_url_2026}/home/events-activities/school-programs/Elevate2026/16.webp`;
    const p17 = `${config.base_image_url_2026}/home/events-activities/school-programs/Elevate2026/17.webp`;
    const p18 = `${config.base_image_url_2026}/home/events-activities/school-programs/Elevate2026/18.webp`;
    const p19 = `${config.base_image_url_2026}/home/events-activities/school-programs/Elevate2026/19.webp`;
    const p20 = `${config.base_image_url_2026}/home/events-activities/school-programs/Elevate2026/20.webp`;
    const p21 = `${config.base_image_url_2026}/home/events-activities/school-programs/Elevate2026/21.webp`;
    const p22 = `${config.base_image_url_2026}/home/events-activities/school-programs/Elevate2026/22.webp`;
    const p23 = `${config.base_image_url_2026}/home/events-activities/school-programs/Elevate2026/23.webp`;
    const p24 = `${config.base_image_url_2026}/home/events-activities/school-programs/Elevate2026/24.webp`;
    const p25 = `${config.base_image_url_2026}/home/events-activities/school-programs/Elevate2026/25.webp`;
    const p26 = `${config.base_image_url_2026}/home/events-activities/school-programs/Elevate2026/26.webp`;
    const p27 = `${config.base_image_url_2026}/home/events-activities/school-programs/Elevate2026/27.webp`;
    const p28 = `${config.base_image_url_2026}/home/events-activities/school-programs/Elevate2026/28.webp`;
    const p29 = `${config.base_image_url_2026}/home/events-activities/school-programs/Elevate2026/29.webp`;
    const p30 = `${config.base_image_url_2026}/home/events-activities/school-programs/Elevate2026/30.webp`;
    const p31 = `${config.base_image_url_2026}/home/events-activities/school-programs/Elevate2026/31.webp`;
    const p32 = `${config.base_image_url_2026}/home/events-activities/school-programs/Elevate2026/32.webp`;
    const p33 = `${config.base_image_url_2026}/home/events-activities/school-programs/Elevate2026/33.webp`;
    const p34 = `${config.base_image_url_2026}/home/events-activities/school-programs/Elevate2026/34.webp`;
   
   
    const photos = [
        {
            src: p1,
            source: p1,
            rows: 1,
            cols: 1,
        },
        {
            src: p2,
            source: p2,
            rows: 1,
            cols: 1,
        },
        {
            src: p3,
            source: p3,
            rows: 1,
            cols: 1,
        }, 
          {
            src: p4,
            source: p4,
            rows: 1,
            cols: 1,
        },  
        {
  src: p5,
  source: p5,
  rows: 1,
  cols: 1,
},
{
  src: p6,
  source: p6,
  rows: 1,
  cols: 1,
},
{
  src: p7,
  source: p7,
  rows: 1,
  cols: 1,
},
{
  src: p8,
  source: p8,
  rows: 1,
  cols: 1,
},
{
  src: p9,
  source: p9,
  rows: 1,
  cols: 1,
},
{
  src: p10,
  source: p10,
  rows: 1,
  cols: 1,
},
{
  src: p11,
  source: p11,
  rows: 1,
  cols: 1,
},
{
  src: p12,
  source: p12,
  rows: 1,
  cols: 1,
},
{
  src: p13,
  source: p13,
  rows: 1,
  cols: 1,
},
{
  src: p14,
  source: p14,
  rows: 1,
  cols: 1,
},
{
  src: p15,
  source: p15,
  rows: 1,
  cols: 1,
},
{
  src: p16,
  source: p16,
  rows: 1,
  cols: 1,
},
{
  src: p17,
  source: p17,
  rows: 1,
  cols: 1,
},
 {
            src: p18,
            source: p18,
            rows: 1,
            cols: 1,
        },
        {
            src: p19,
            source: p19,
            rows: 1,
            cols: 1,
        },
        {
            src: p20,
            source: p20,
            rows: 1,
            cols: 1,
        }, 
          {
            src: p21,
            source: p21,
            rows: 1,
            cols: 1,
        },  
{
  src: p22,
  source: p22,
  rows: 1,
  cols: 1,
},
{
  src: p23,
  source: p23,
  rows: 1,
  cols: 1,
},
{
  src: p24,
  source: p24,
  rows: 1,
  cols: 1,
},
{
  src: p25,
  source: p25,
  rows: 1,
  cols: 1,
},
{
  src: p26,
  source: p26,
  rows: 1,
  cols: 1,
},
{
  src: p27,
  source: p27,
  rows: 1,
  cols: 1,
},
{
  src: p28,
  source: p28,
  rows: 1,
  cols: 1,
},
{
  src: p29,
  source: p29,
  rows: 1,
  cols: 1,
},
{
  src: p30,
  source: p30,
  rows: 1,
  cols: 1,
},
{
  src: p31,
  source: p31,
  rows: 1,
  cols: 1,
},
{
  src: p32,
  source: p32,
  rows: 1,
  cols: 1,
},
{
  src: p33,
  source: p33,
  rows: 1,
  cols: 1,
},
{
  src: p34,
  source: p34,
  rows: 1,
  cols: 1,
},




    ];

    return (
        <Main>
            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box >
                                <Typography variant='h4' align='center'>
                               Elevate
                                </Typography>
                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                                 Date: 21 July 2026
                                </Typography>
                                {/* <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                “If you believe in yourself and have dedication and determination and never quit, you'll be a winner. The price of victory is high but so are the rewards.”

                                <br />
                            </Typography> */}

                                <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
National Public School, Yeshwanthpur, proudly hosted <strong>ELEVATE 2026</strong>, its prestigious Inter-School Sports Meet, on <strong>Tuesday, 21 July 2026</strong>, bringing together talented young athletes from leading schools across Bengaluru for a day of spirited competition and camaraderie.
                               <br></br>
The championship featured competitions in<strong> Chess, Table Tennis, Volleyball and Basketball</strong>, with participants competing in the <strong>Under-11, Under-14, Under-16 and Under-17</strong> categories for both boys and girls. The event provided a vibrant platform for students to demonstrate their sporting excellence while embracing the true spirit of healthy competition.
                               <br></br>
                               The programme commenced with a magnificent <strong>March Past</strong>, as contingents from the participating schools marched with pride and precision, reflecting discipline, unity and sportsmanship. The event was formally inaugurated by <strong>Principal Ms. Sheeja Manoj</strong>, who welcomed the participants and encouraged them to uphold the values of perseverance, teamwork, resilience and fair play both on and off the field.
                                                               <br></br>
                              To ensure the highest standards of competition, the tournaments were officiated by <strong>qualified referees and arbiters from the respective sports associations.</strong> Throughout the day, the courts and playing arenas witnessed remarkable displays of talent, determination and sporting spirit, making every match both competitive and inspiring.
                               <br></br>
The event concluded with a grand<strong> Valedictory Ceremony</strong>, during which Principal Ms. Sheeja Manoj congratulated all the participants for their commendable performances and presented the prizes to the winners across the various age categories. ELEVATE 2026 concluded on a celebratory note, reaffirming National Public School, Yeshwanthpur's commitment to nurturing excellence in sports while fostering the enduring values of integrity, discipline, teamwork and unity.
                                                               <br></br>

                                </Typography>
                            </Box>
                            <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
Celebrating the spirit of teamwork and determination.
                                <br />
                            </Typography>

                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 200 : 100}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                    <Box marginBottom={4}>
                            <Sidebar2026/>
                        </Box> 
                        <Box marginBottom={4}>
                            <Archive2022/>
                        </Box>

                    </Grid>
                </Grid>
            </Container>
        </Main>

    );
};

export default Elevate2026;